import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["label", "name", "placeholder", "size", "showErrorInContext", "validate", "inputProps", "inputGroupProps", "buttonProps", "defaultValue", "buttonText"];
import CUIButton from 'connect-dot-com-ui-components/Components/CUIButton/CUIButton';
import { HomepageCardBackgroundGradient } from 'connect-dot-com-ui-components/Components/CUIHomepageCard/utils/backgroundGradients';
import CUIText from 'connect-dot-com-ui-components/Components/CUIText/CUIText';
import { CUIFormControl, CUIFormErrorMessage, CUIFormLabel } from 'connect-dot-com-ui-components/Components/Forms/CUIFormControl';
import CUIInput from 'connect-dot-com-ui-components/Components/Forms/CUIInput';
import CUIInputGroup from 'connect-dot-com-ui-components/Components/Forms/CUIInputGroup';
import CUIInputRightAddon from 'connect-dot-com-ui-components/Components/Forms/CUIInputRightAddon';
import { useField } from 'react-final-form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FFSingleInputForm(_ref) {
  let {
      label,
      name,
      placeholder,
      size = 'sm',
      showErrorInContext = true,
      validate = () => {},
      inputProps = {},
      inputGroupProps = {},
      buttonProps = {},
      defaultValue,
      buttonText
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    input,
    meta
  } = useField(name, {
    validate,
    defaultValue
  });
  return /*#__PURE__*/_jsxs(CUIFormControl, Object.assign({
    isInvalid: meta.error && meta.touched
  }, rest, {
    children: [label && /*#__PURE__*/_jsx(CUIFormLabel, {
      htmlFor: name,
      children: label
    }), /*#__PURE__*/_jsxs(CUIInputGroup, Object.assign({
      size: size
    }, inputGroupProps, {
      children: [/*#__PURE__*/_jsx(CUIInput, Object.assign({
        id: name,
        size: size,
        placeholder: placeholder,
        borderLeftRadius: "full"
      }, input, inputProps)), /*#__PURE__*/_jsx(CUIInputRightAddon, {
        padding: 0,
        borderRightRadius: "full",
        children: /*#__PURE__*/_jsx(CUIButton, Object.assign({
          size: size,
          padding: 0,
          isDisabled: meta.error || meta.submitting,
          _disabled: {
            pointerEvents: 'none',
            background: 'GREYSCALE.SATELLITE',
            color: 'GREYSCALE.COMET'
          },
          _hover: {
            background: `linear-gradient(${HomepageCardBackgroundGradient.orangeToMagenta})`,
            opacity: 0.9
          },
          _loading: {
            background: `linear-gradient(${HomepageCardBackgroundGradient.orangeToMagenta})`,
            opacity: 0.9,
            color: '#FFF'
          },
          background: `linear-gradient(${HomepageCardBackgroundGradient.orangeToMagenta})`,
          borderRightRadius: "full",
          borderLeftRadius: "initial",
          fontWeight: 300,
          color: "#FFF"
        }, buttonProps, {
          children: /*#__PURE__*/_jsx(CUIText, {
            marginLeft: 4,
            marginRight: 4,
            fontSize: "sm",
            children: buttonText
          })
        }))
      })]
    })), showErrorInContext && /*#__PURE__*/_jsx(CUIFormErrorMessage, {
      fontSize: "xs",
      children: meta.error
    })]
  }));
}